'use client'
import cl from 'clsx'
import useAuthStore from '@/store/auth';
import {useEffect, useRef, useState} from 'react'
import {MdKeyboardArrowDown} from "react-icons/md";
import Link from 'next/link';
import routes from '@/utils/routes';
import {usePathname} from 'next/navigation'
import styles from './styles.module.css'
import './styles.css'

export default function Select({options, defaultText, type, onClick, onDataFromChild, dict}) {
    const {tools, pa_tool, sa_tool, lca_tool} = dict.select.tools_list
    const {my_account, log_out} = dict.select.account
    const {logout} = useAuthStore();
    const pathname = usePathname()
    const [open, setOpen] = useState(false)
    const [selected, setSelected] = useState(defaultText)
    const [selectedId, setselectedId] = useState(null)
    const [uuid, setUuid] = useState(null)
    const selectRef = useRef(null)

    const getNavLink = (title) => {
        switch (title) {
            case pa_tool:
                return routes.pa_tool;
            case sa_tool:
                return routes.sa_tool;
            case lca_tool:
                return routes.lca_tool;
            case my_account:
                return routes.account;
            default:
                return "#";
        }
    }

    const select = (id, title, uuid, short_name) => {
        setUuid(uuid);
        setselectedId(id);
        setOpen(!open);

        if (onClick) {
            onClick();
        }

        const pathWithoutLocale = pathname.split('/').slice(2).join('/');

        if (type === "account") {
            if (pathWithoutLocale === 'contacts') {
                setSelected(my_account);
            } else {
                setSelected(title || short_name);
            }
        } else {
            setSelected(title || short_name);
        }

        if (onDataFromChild) {
            onDataFromChild(title, uuid);
        }

        if (title === log_out) {
            logout();
        }
    };

    useEffect(() => {
        const pathWithoutLocale = pathname.split('/').slice(2).join('/');

        if (type === "account") {
            if (pathWithoutLocale === 'account') {
                setSelected(my_account);
            } else {
                setSelected(defaultText);
            }
        }
    }, [pathname, type, my_account, defaultText]);

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setOpen(false)
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside)
        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [])

    useEffect(() => {
        const pathWithoutLocale = pathname.split('/').slice(2).join('/');

        if (pathWithoutLocale === '' && type === 'nav') {
            setSelected(tools);
        }
        if (pathWithoutLocale === 'faq' && type === 'nav') {
            setSelected(tools);
        }
        if (pathWithoutLocale === 'contacts' && type === 'nav') {
            setSelected(tools);
        }
        if (pathWithoutLocale === 'pa-tool' && type === 'nav') {
            setSelected(pa_tool);
        }
        if (pathWithoutLocale === 'pa-tool/quiz-1' && type === 'nav') {
            setSelected(pa_tool);
        }
        if (pathWithoutLocale === 'pa-tool/quiz-2' && type === 'nav') {
            setSelected(pa_tool);
        }
        if (pathWithoutLocale === 'pa-tool/quiz-3' && type === 'nav') {
            setSelected(pa_tool);
        }
        if (pathWithoutLocale === 'pa-tool/quiz-4' && type === 'nav') {
            setSelected(pa_tool);
        }
        if (pathWithoutLocale === 'pa-tool/quiz-5' && type === 'nav') {
            setSelected(pa_tool);
        }
        if (pathWithoutLocale === 'pa-tool/results' && type === 'nav') {
            setSelected(pa_tool);
        }
        if (pathWithoutLocale === 'sa-tool' && type === 'nav') {
            setSelected(sa_tool);
        }
        if (pathWithoutLocale === 'sa-tool/quiz-1' && type === 'nav') {
            setSelected(sa_tool);
        }
        if (pathWithoutLocale === 'sa-tool/quiz-2' && type === 'nav') {
            setSelected(sa_tool);
        }
        if (pathWithoutLocale === 'sa-tool/quiz-3' && type === 'nav') {
            setSelected(sa_tool);
        }
        if (pathWithoutLocale === 'sa-tool/quiz-4' && type === 'nav') {
            setSelected(sa_tool);
        }
        if (pathWithoutLocale === 'sa-tool/quiz-5' && type === 'nav') {
            setSelected(sa_tool);
        }
        if (pathWithoutLocale === 'sa-tool/sa-results' && type === 'nav') {
            setSelected(sa_tool);
        }
        if (pathWithoutLocale === 'lca-tool' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'lca-tool/quiz-1' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'lca-tool/quiz-2' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'lca-tool/quiz-3' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'lca-tool/quiz-4' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'lca-tool/quiz-5' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'lca-tool/quiz-6' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'lca-tool/quiz-7' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'lca-tool/lca-results' && type === 'nav') {
            setSelected(lca_tool);
        }
        if (pathWithoutLocale === 'account' && type === 'nav') {
            setSelected(tools);
        }
    }, [pathname]);

    return (
        <div className={cl(
            styles.select,
            type === "account" && styles.select__account,
            type === "quiz" && styles.select__account,
            type === "title" && styles.select__title_project,
            type === "dark-title" && styles.select__title_project,
            type === "dark-title" && styles.select__dark
        )}
             ref={selectRef}
        >
            <div
                onClick={() => setOpen(!open)}
                className={cl(
                    styles.select__lable,
                    type === "nav" && styles.select__lable_nav,
                    type === "title" && styles.select__lable_title,
                    type === "dark-title" && styles.select__lable_title_dark,
                )}
            >
                <p className={cl(
                    styles.select__title,
                    type === "nav" && styles.select__title_nav,
                    type === "nav" && "custom-underline",
                    type === "account" && styles.select__title_account,
                    selected !== 'Type of question' && styles.select__selected_text,
                    selected === "Category" && styles.select__default_text,
                    selected === "Product/asset" && styles.select__default_text,
                )}
                >
                    {selected ? selected : defaultText}
                </p>
                <MdKeyboardArrowDown className={cl(
                    styles.select_arrow,
                    type === 'dark-title' && styles.select__arrow_white,
                    open && styles.select__arrow_top
                )}/>
            </div>

            {open && (
                <div className={cl(
                    styles.select__selectedList,
                    type === "nav" && styles.select__selectedList_nav,
                    type === "quiz" && styles.select__selectedList_quiz,
                    type === "title" && styles.select__selectedList_title
                )}>
                    {options.map(({title, uuid, short_name}, index) => {
                        return (
                            <div
                                key={index}
                                onClick={() => select(index + 1, title, uuid, short_name)}
                                className={cl(
                                    styles.select__text,
                                    {[styles.active]: selectedId == index + 1}
                                )}
                            >
                                {
                                    type === "contact-us" ?
                                        title ? title : short_name
                                        :
                                        <Link href={getNavLink(title)}>
                                            {title ? title : short_name}
                                        </Link>
                                }
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
